module.exports = "<form name=\"form\"\n  class=\"radio-menu row\">\n  <my-radio-button ng-repeat=\"item in myMenu.items\"\n    class=\"{{layout}}\"\n    my-label=\"item.label\"\n    my-id=\"item.ref\"\n    ng-model=\"myMenu.radio.value\"\n    my-click=\"changeState(item.ref)\"\n    my-value=\"item.ref\">\n  </my-radio-button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/menus/myRadioMenu.html
// module id = 1235
// module chunks = 0